import { IBrand } from "../types/brands";

const isModuleEnabled = (brand: IBrand, moduleName: string): boolean => {
    const module = brand?.modules[moduleName];

    return module?.enabled ?? false;
};

export const hasVerticalAssortmentAccess = (me: any, brand: IBrand, verticalAssortmentsEnabled: boolean): boolean => {
    if (!verticalAssortmentsEnabled) {
        return verticalAssortmentsEnabled;
    }
    const hasPermission = me?.hasPermission("vertical_assortment_access");
    const moduleEnabled = isModuleEnabled(brand, "vertical_assortments");

    return hasPermission && moduleEnabled;
};
